// const toQueryString = (path, query = {}) => {
//   let link = path;
//   const queryKeys = Object.keys(query);
//   if (queryKeys.length) {
//     for (let i = 0; i < queryKeys.length; i = i + 1) {
//       if (query[queryKeys[i]]) {
//         link = Array.isArray(query[queryKeys[i]])
//           ? query[queryKeys[i]].reduce((acc, item) => `${acc}${queryKeys[i]}[]=${item}&`, `${link}`)
//           : `${link}${queryKeys[i]}=${query[queryKeys[i]]}&`;
//       }
//     }
//   }

//   return link;
// };

const toQueryString = (path: string, query: Record<string, any> = {}, includeEmptyArrays = false) => {
  const parts: string[] = [];

  for (const [key, value] of Object.entries(query)) {
    if (value === null || value === undefined) continue;

    if (Array.isArray(value)) {
      if (value.length > 0) {
        for (const item of value) {
          parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
        }
      } else if (includeEmptyArrays) {
        // явно передати порожній масив
        parts.push(`${encodeURIComponent(key)}[]=`); 
      }
    } else if (value !== '') {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }

  if (parts.length === 0) return path;

  const hasQuestion = path.includes('?');
  const sep = hasQuestion ? (path.endsWith('?') || path.endsWith('&') ? '' : '&') : '?';
  return `${path}${sep}${parts.join('&')}`;
};

export default toQueryString;
